/*global jQuery, google */
(function($) {

  'use strict';

  $(function() {
	  

    $('body').on('click', '.invia-contatto', function() {
      var validator = $('#form-contatto').validate({
        focusInvalid: false,
        onkeyup: false,
        onfocusout: false,
        errorElement: 'p',
        errorPlacement: function(error) {
          var tmpl = '<span class="glyphicon glyphicon-remove-circle" style="font-size: 70px; color:orange;"></span><br><br>' +
          '<h4>' + $(error).html() + '</h4><br>';

          attivaModal(tmpl, ['Chiudi'], ['']);

          $('div#errors').show();
          if ($('div#errors').html() === '') {
            error.appendTo('div#errors');
          }
        },
        rules: {
          nominativo: {
            required: true
          },
          ragsoc: {
            required: true
          },
          email: {
            required: true,
            email: true
          },
          telefono: {
            required: true
          },
          localita: {
            required: true
          },
          check_privacy: {
            required: true
          },
        },
        messages: {
          nominativo: {
            required: setup.texts.testi['inserire-nome']
          },
          ragsoc: {
            required: setup.texts.testi['inserire-azienda']
          },
          email: {
            required: setup.texts.testi['inserire-mail'],
            email: setup.texts.testi['mail-corretta']
          },
          telefono: {
            required: setup.texts.testi['inserire-telefono']
          },
          localita: {
            required: setup.texts.testi['inserire-localita']
          },
          check_privacy: {
            required: setup.texts.testi['check-privacy']
          },
        },
        invalidHandler: function() {
          $('div#errors').html('');
        }
      });

      var arr = {};
      
      arr.nominativo = $('#nominativo').val();
      arr.ragsoc = $('#ragsoc').val();
      arr.email = $('#email').val();
      arr.telefono = $('#telefono').val();
      arr.localita = $('#localita').val();
      arr.categoriaprodotto = $('#categoriaprodotto').val();
      arr.codiceprodotto = $('#codiceprodotto').val();
      arr.messaggio = $('#messaggio').val();

      arr.check_privacy = $('#check_privacy').is(':checked');
      arr.check_commercial = $('#check_commercial').is(':checked');

      arr.idpagina = $('#idpagina').val();
      arr.pagina = $('#pagina').val();
      var jsonString = JSON.stringify(arr);


      if (validator.form()) {
        var tmpl = '<span class="glyphicon glyphicon-time" style="font-size: 70px; color:orange;"></span><br><br>' +
        '<h4>Stiamo elaborando la sua richiesta, attendere un attimo...</h4><br><br>';
        attivaModal(tmpl, null, null);

        var fd = new FormData();
        fd.append('action', 'invia-contatto');
        fd.append('obj', jsonString);

        $.ajax({
          url: '/ajax/function.php',
          method: 'POST',
          contentType: false,
          processData: false,
          data: fd,
          success: function(ret) {
            var arr = ret.split('|');
            var tmpl = '';

            if (arr[0] === '1') {
              tmpl = '<span class="glyphicon glyphicon-send" style="font-size: 70px; color:orange;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
              $('#email').val('');
              $('#nome').val('');
              $('#privacy').val('');
              $('#telefono').val('');
              $('#messaggio').val('');
              $('#captcha').val('');
              
              //gtag('event', 'click', {
              //  'event_category': 'Contact',
              //  'event_label': 'compilazione form'
              //});
              

            } else {
              tmpl = '<span class="glyphicon glyphicon-remove-sign" style="font-size: 70px; color:orange;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
            }
            attivaModal(tmpl, ['Chiudi'], [''], null);
          }
        });
        return false;
      }
      return false;
    });


    var attivaModal = function(message, buttons, idButtons, callBack) {
      $('.modal-body p').hide();
      $('.modal-body p').html(message);
      $('.modal-body p').show();

      if (!$('.modal').hasClass('in')) {
        $('.modal').modal('show');
      }

      $('.modal-footer').html('');

      if (typeof buttons !== 'undefined' && buttons !== null) {
        if (buttons.length > 0) {
          $.each(buttons, function(index, value) {
            if (idButtons[index] === '') {
              $('.modal-footer').append('<button type="button" class="btn btn-default" data-dismiss="modal">' + value + '</button>');
            } else {
              $('.modal-footer').append('<button type="button" class="btn btn-default" id="modal-action-' + idButtons[index] + '">' + value + '</button>');
            }
          });
        }
      }
      if (typeof callBack === 'function') {
        callBack();
      }
    };



  });

}(jQuery));
